module.exports = __webpack_public_path__ + "media/images/place de stationnement dans la rue-dc72cff9463b743e7c5e192269ba87fc.svg";